export const createEntriesRequests = (client) => ({
    listEntries: async (params) => {
        const { data, meta, links } = await client.api.get("entries", {
            params: params,
        });
        return { data, meta, links };
    },
    findEntry: async (params) => {
        const { data } = await client.api.get(`entries/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    updateEntry: async (payload) => {
        const { data } = await client.api.update("entries", payload);
        return { data };
    },
    listEntryAssignableBreweries: async (payload) => {
        const { data, meta, links } = await client.api.get(`entries/${payload?.id}/assignable_breweries`);
        return { data, meta, links };
    },
    cancelEntry: async (payload) => {
        const { data } = await client.api.request({
            type: "entries",
            method: "PATCH",
            url: "/entries/cancel",
            body: payload,
        });
        return { data };
    },
    deleteEntry: async (payload) => {
        const { data } = await client.api.request({
            type: "entries",
            method: "DELETE",
            url: `/entries/${payload?.id}`,
        });
        return { data };
    },
    markEntryAsSent: async (payload) => {
        const { data } = await client.api.request({
            type: "entries",
            method: "PATCH",
            url: "/entries/mark_as_sent",
            body: payload,
        });
        return { data };
    },
    preJudgeCheckEntry: async (payload) => {
        const { data } = await client.api.request({
            type: "entry",
            method: "POST",
            url: "/entries/pre_judge_check",
            body: payload,
        });
        return { data };
    },
    checkEntryNameUniqueness: async (payload) => {
        const res = await client.api.request({
            url: "/entries/uniqueness",
            type: "entry",
            body: payload,
            method: "POST",
        });
        return res?.isUnique;
    },
    registerEntry: async (payload) => {
        const { data, meta } = await client.api.create("entry", payload);
        return { data, meta };
    },
    downloadEntryProforma: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: `/entries/${payload?.id}/download_proforma`,
            body: payload,
        });
        return { data };
    },
    downloadEntryLabels: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: `${client.getApiUrl()}/entries/${payload?.id}/download_labels`,
            body: payload,
        });
        return data;
    },
    checkInEntry: async (payload) => {
        const { data } = await client.api.request({
            type: "entry",
            method: "POST",
            url: "/entries/check_in",
            body: payload,
        });
        return { data };
    },
    downloadRecodeTokens: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/download_tokens_for_recode",
            body: payload,
        });
        return data;
    },
    recodeEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/recode",
            body: payload,
        });
        return data;
    },
    checkOutEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/check_out",
            body: payload,
        });
        return data;
    },
    preJudgeCheck: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/pre_judge_check",
            body: payload,
        });
        return data;
    },
    decideTableEntry: async (payload) => {
        const response = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/table_decision",
            body: payload,
        });
        return response?.data ?? response;
    },
    promoteEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/promote",
            body: payload,
        });
        return data;
    },
    demoteEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/demote",
            body: payload,
        });
        return data;
    },
    generateEntriesReport: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/report",
            body: payload,
        });
        return { data };
    },
    generateFinalistsReport: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/finalists_report",
            body: payload,
        });
        return { data };
    },
    disqualifyEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/disqualify",
            body: payload,
        });
        return { data };
    },
    markEntryAsPaid: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/mark_as_paid",
            body: payload,
        });
        return { data };
    },
    markEntryAsJudged: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/mark_as_judged",
            body: payload,
        });
        return { data };
    },
    reEvaluateEntry: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "entries",
            url: "/entries/re_evaluate",
            body: payload,
        });
        return { data };
    },
    syncEntries: async (payload) => {
        const response = await client.axios.request({
            method: "POST",
            url: "/entries/sync",
            data: payload,
        });
        const res = response?.data?.data || response?.data || {};
        return { data: res };
    },
});
//# sourceMappingURL=index.js.map